import { masterRecordsSlice, usePagination } from "@/slice/masterRecordsSlice"
import { TablePagination as MUITablePagination } from "@mui/material"
import React from "react"
import { useDispatch } from "react-redux"

export const TablePagination = (props: { tableName: string; count: number }) => {
	const { tableName, count } = props

	const dispatch = useDispatch()
	const pagination = usePagination(tableName)

	const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
		dispatch(
			masterRecordsSlice.actions.setPagination({
				tableName,
				startIndex: newPage * pagination.pageSize,
				pageSize: pagination.pageSize,
			}),
		)
	}

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		dispatch(
			masterRecordsSlice.actions.setPagination({
				tableName,
				startIndex: 0,
				pageSize: parseInt(event.target.value, 10),
			}),
		)
	}

	return (
		<MUITablePagination
			component="div"
			count={count}
			page={pagination.startIndex / pagination.pageSize}
			onPageChange={handleChangePage}
			rowsPerPage={pagination.pageSize}
			onRowsPerPageChange={handleChangeRowsPerPage}
			labelRowsPerPage="表示件数"
			labelDisplayedRows={({ from, to, count }) => `${from}件から${to}件目を表示中（全${count}件）`}
		/>
	)
}
